import { forwardRef } from 'react';
import { H2 } from 'atoms/Typography';
import { WizardStepProps } from '../data/types';
import styles from './styles.module.css';

export const WizardStep = forwardRef<HTMLDivElement, WizardStepProps>(
  ({ question, children }, ref) => {
    return (
      <div ref={ref} className={styles.questionWrapper}>
        <H2 className={styles.questionCopy}>{question}</H2>
        {children}
      </div>
    );
  },
);
